import { render } from "./VPAContent.vue?vue&type=template&id=61287988&scoped=true"
import script from "./VPAContent.vue?vue&type=script&lang=js"
export * from "./VPAContent.vue?vue&type=script&lang=js"

import "./VPAContent.vue?vue&type=style&index=0&id=61287988&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61287988"]])

export default __exports__